export * from './gpdr-info-redirect-sheet.component';
